import { createHelpers } from 'vuex-map-fields'

const { getClientField, updateClientField } = createHelpers({
  getterType: 'getClientField',
  mutationType: 'updateClientField'
})

const state = {
  isCompany: false,
  checkDelivery: false,
  billingAddress: {
    title: '',
    company: '',
    firstName: '',
    lastName: '',
    street: '',
    number: null,
    zip: null,
    city: '',
    country: {
      name: 'Deutschland',
      code: 'DE'
    },
    salesTax: null,
    phone: null,
    addition: '',
    mail: ''
  },
  deliveryAddress: {
    title: '',
    company: '',
    firstName: '',
    lastName: '',
    street: '',
    number: null,
    zip: null,
    city: '',
    country: {
      name: 'Deutschland',
      code: 'DE'
    },
    phone: null,
    addition: ''
  },
  paypalDeliveryAddress: {}
}

const mutations = {
  updateClientField,
  'SET_PAYPAL_DELIVERYADDRESS' (state) {
    state.paypalDeliveryAddress = state.checkDelivery ? state.deliveryAddress : state.billingAddress
  }
}

const actions = {
  setPaypalDeliveryaddress: ({ commit }) => {
    commit('SET_PAYPAL_DELIVERYADDRESS')
  }
}

const getters = {
  isCompany: state => {
    return state.isCompany
  },
  checkDelivery: state => {
    return state.checkDelivery
  },
  billingAddress: state => {
    return state.billingAddress
  },
  deliveryAddress: state => {
    return state.deliveryAddress
  },
  paypalDeliveryAddress: state => {
    return state.paypalDeliveryAddress
  },
  getClientField
}

export default {
  state,
  getters,
  mutations,
  actions
}
